import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index.ts';

export const selectIsIbanCheckerDrawerOpen = (state: RootState) => state.ui.isIbanCheckerDrawerOpen;
export const selectIsPersonalInfoDrawerOpen = (state: RootState) => state.ui.isPersonalInfoDrawerOpen;
export const selectIsIRISPaymentDrawerOpen = (state: RootState) => state.ui.isIRISPaymentDrawerOpen;
export const selectIRISPaymentDrawerPayload = (state: RootState) => state.ui.irisDrawerPayload;
export const selectIsInsuredCreateFormOpen = (state: RootState) => state.ui.isInsuredCreateFormOpen;
export const selectisInsuredUpdateFormOpen = (state: RootState) => state.ui.isInsuredUpdateFormOpen;
export const selectIsCreateCorrespondenceDrawerOpen = (state: RootState) => state.ui.isCreateCorrespondenceDrawerOpen;
export const selectIsInsuredUpdateFormSubmittable = (state: RootState) => state.ui.canInsuredFormBeSubmitted;

export const isInsuredFormOpen = createSelector(
  [selectIsInsuredCreateFormOpen, selectisInsuredUpdateFormOpen],
  (create, update) => create || update
);

export const selectSnackbarMessages = (state: RootState) => state.ui.snackbar.messages;
export const selectSnackbarMessagesCount = (state: RootState) => state.ui.snackbar.messages.length;
